import React from 'react';

import { List, ListItem, ListItemIcon } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const MobileNavTabs = props => {
  const classes = useStyles();
  const { list, handleChangeActiveTab } = props;

  return (
    <List className={classes.list} component="div">
      {list.map(({ label, id }) => (
        <ListItem
          onClick={() => handleChangeActiveTab(id)}
          key={id}
          className={classes.item}
          button
          divider
          disableTouchRipple
        >
          {label}
          <ListItemIcon className={classes.icon}>
            <Icon name="forwardArrow" />
          </ListItemIcon>
        </ListItem>
      ))}
    </List>
  );
};

MobileNavTabs.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleChangeActiveTab: PropTypes.func.isRequired,
};

export default MobileNavTabs;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/MobileNavTabs/MobileNavTabs.js